import React from 'react'
import coverEn from '../../image/cover-en.jpg'
import coverFa from '../../image/cover-fa.jpg'
// import farsiIntor from '../../video/Promo farsi.mp4'
// import englishIntor from '../../video/Promo English.mp4'
import { ThemeContext } from '../../theme/DarkMode';
import Fade from 'react-reveal/Fade';
import { SideBar } from './SideBar';
import { useTranslation } from 'react-i18next';

export const VideoPlayer = () => {

    const { theme } = React.useContext(ThemeContext);
    const { t, i18n } = useTranslation()

    React.useEffect(() => {

    }, [i18n.language])

    return (
        <Fade bottom>
            <div className={theme === 'light' ? 'light-video-player-wrapper' : 'video-player-wrapper'} id='intro'>
                <h1 className={theme === 'light' ? 'light-title-header' : 'title-header'}>{t('video.title')}</h1>
                <div className='video-contnet-wrapper'>
                    <SideBar />
                    <video
                        src={i18n.language === 'en' ? 'https://ahil.s3.ir-thr-at1.arvanstorage.ir/statics/Promo-English.59444bb608e611a420dd.mp4' : 'https://ahil.s3.ir-thr-at1.arvanstorage.ir/statics/Promo-farsi.7dbfecc28e5c4ee26cab.mp4'}
                        controls
                        poster={i18n.language === "en" ? coverEn : coverFa}
                        className={theme === 'light' ? 'light-video' : 'video'}
                    />
                </div>
            </div>
        </Fade>
    )
}
